<template>
  <div
    v-if="data?.item_count > 0"
    class="mini-cart__totals"
  >
    <ul class="mini-cart__totals-list pt-4">

      <li class="mini-cart__totals-item flex justify-between w-full">
        <span class="font-bold">Total</span>
        <span>{{ formatMoney(data?.total_price) }}</span>
      </li>
      <li  
        v-if="data?.total_price != data?.original_total_price"
        class="mini-cart__totals-item flex justify-between w-full">
        <span class="font-bold">Subtotal</span>
        <span class="opacity-50 ">{{ formatMoney(data?.original_total_price) }}</span>
      </li>
     
      <!-- <li
        v-if="data?.cart_level_discount_applications?.length"
        class="mini-cart__totals-item flex justify-between w-full">
        <span class="font-bold">cart_level_discount_applications:</span>
        <span
          v-for="dis in data?.cart_level_discount_applications"
          :key="dis.key"
        >
          {{ dis?.title }} {{ formatMoney(dis?.value) }}
        </span>
      </li> -->

      <li
        v-if="data?.total_discount > 0"
        class="mini-cart__totals-item flex justify-between w-full">
        <span class="font-bold">Discount</span>
        <span>-{{ formatMoney(data?.total_discount) }}</span>
      </li>

      <!-- <li
        v-if="data?.discount_codes?.length"
        class="mini-cart__totals-item flex justify-between w-full"
      >
        <span class="font-bold">discount_codes:</span>
        <span>{{ data?.discount_codes }}</span>
      </li> -->

    </ul>
  </div>
</template>

<script setup lang="ts">
import formatMoney from '../helpers/format-money.js';
defineProps<{
  data: {
    item_count: number
    original_total_price?: any
    total_price?: any
    items_subtotal_price?: any
    cart_level_discount_applications?: any
    total_discount?: any
    discount_codes?: any
  }
}>()
</script>
